import { axiosInstances } from 'utilities/axios/Instances/axios.instances';
const findBySkills = () => {
  return axiosInstances.withAuthToken().get('/employee-skills/');
};
export const EmployeesSkillsService = { findBySkills };
